export const ToastSeverity = {
	SUCCESS: 'success',
	ERROR: 'error',
} as const
export type ToastSeverity = (typeof ToastSeverity)[keyof typeof ToastSeverity]
